const intersection = (arrA: any[], arrB: any[]) => arrA.filter((x) => arrB.includes(x));

const dataUtils = {
  intersection,
};
export default dataUtils;
